import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CMSPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the CMS portal
    navigate('/app/admin/cms/portal');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to CMS Portal...</p>
      </div>
    </div>
  );
};

export default CMSPage
